import { EqlFieldName } from '@modules/common/constants';
import { CSATFormulaDefinition } from '@modules/quantify/components/AggregateFormulaResultTable/QuantifyFormulaDefinition/CSATFormulaDefinition';
import { MeanFormulaDefinition } from '@modules/quantify/components/AggregateFormulaResultTable/QuantifyFormulaDefinition/MeanFormulaDefinition';
import { SumFormulaDefinition } from '@modules/quantify/components/AggregateFormulaResultTable/QuantifyFormulaDefinition/SumFormulaDefinition';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import {
  IntermediateCsatFuncValue,
  IntermediateMeanFuncValue,
  IntermediateNpsFuncValue,
} from 'generated/graphql';
import { EQLFunctionName } from 'v2/core/repository/eql/types';
import { NPSFormulaDefinition } from './NPSFormulaDefinition';

interface QuantifyFormulaDefintionParams {
  value: number;
  nps?: IntermediateNpsFuncValue;
  csat?: IntermediateCsatFuncValue;
  mean?: IntermediateMeanFuncValue;
}

export function QuantifyFormulaDefinition({
  nps,
  csat,
  mean,
  value,
}: QuantifyFormulaDefintionParams) {
  const formulaID = useQuantifyStore(({ query }) => query.formulaID);
  const groupBy = useQuantifyStore(({ query }) => query.groupBy);

  if (groupBy?.field === EqlFieldName.FeedbackRecords) {
    return <>View Feedback</>;
  }

  if (nps && EQLFunctionName.NPS === formulaID) {
    return (
      <NPSFormulaDefinition
        nps={{
          value: value ?? 0,
          ...nps,
        }}
      />
    );
  }

  if (csat && EQLFunctionName.CSAT === formulaID) {
    return (
      <CSATFormulaDefinition
        csat={{
          value: value ?? 0,
          ...csat,
        }}
      />
    );
  }

  if (EQLFunctionName.Mean === formulaID) {
    return (
      <MeanFormulaDefinition
        mean={{
          value: value ?? 0,
          ...mean,
        }}
      />
    );
  }

  if (EQLFunctionName.Sum === formulaID) {
    return <SumFormulaDefinition sum={value} />;
  }

  return null;
}
